// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ukfMz4 {
  background: var(--background-white);
  padding: var(--spacing-3);
  padding-bottom: 0;
  flex: 1;
}

.XSIWZd {
  border-collapse: collapse;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  width: 100%;
}

.PzVCHs,
.H8z0pY {
  display: grid;
  grid-template-columns: 150px 138px 200px auto;
}

.m4L2dB {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.mp7Ece {
  background-color: var(--surface-neutral-pale);
}

.WYwxwE {
  background-color: var(--background-white);
}

.QQ8XxB,
.nDkUSv {
  align-content: center;
  box-sizing: border-box;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  min-height: 48px;
  overflow-wrap: break-word;
  padding: var(--spacing-2);
  text-align: left;
}

.QQ8XxB {
  position: relative;
}

.nDkUSv {
  font-weight: var(--font-weight-regular);
}

.AKpPSf {
  font-weight: var(--font-weight-semibold);
}

.SV7d6Y {
  align-items: center;
  background: transparent;
  border: 0;
  cursor: col-resize;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: calc(-1 * var(--spacing-0-5));
  top: 0;
  touch-action: none;
  user-select: none;
  width: var(--spacing-1);
  z-index: 1;
}

.SV7d6Y::before {
  background-color: var(--stroke-neutral-silver, #cccccc);
  content: '';
  height: 60%;
  width: 1px;
}

.SV7d6Y:hover::before,
.SV7d6Y:active::before {
  background-color: var(--stroke-neutral-dark);
  width: 2px;
}

.SV7d6Y:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: calc(-1 * var(--spacing-0-5));
}

/* Responsive design */
@media (max-width: 768px) {
  .ukfMz4 {
    padding: var(--spacing-3);
  }

  .PzVCHs,
  .H8z0pY {
    grid-template-columns: 1fr;
    gap: var(--spacing-1);
  }

  .QQ8XxB {
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
  }

  .nDkUSv {
    padding: var(--spacing-1) 0;
  }

  .QGnuau,
  .G6DKxf,
  .zuTPlf,
  .x00dYM,
  .XzhAwG {
    font-size: var(--font-size-xs);
  }

  .dQQEGm {
    flex-direction: row;
    gap: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorCardTrackingPage/components/Timeline/Timeline.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,wCAAwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;;IAKE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF","sourcesContent":[".timelineContainer {\n  background: var(--background-white);\n  padding: var(--spacing-3);\n  padding-bottom: 0;\n  flex: 1;\n}\n\n.timelineTable {\n  border-collapse: collapse;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.timelineHeader,\n.timelineRow {\n  display: grid;\n  grid-template-columns: 150px 138px 200px auto;\n}\n\n.timelineBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.timelineRowEven {\n  background-color: var(--surface-neutral-pale);\n}\n\n.timelineRowOdd {\n  background-color: var(--background-white);\n}\n\n.headerCell,\n.timelineCell {\n  align-content: center;\n  box-sizing: border-box;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  min-height: 48px;\n  overflow-wrap: break-word;\n  padding: var(--spacing-2);\n  text-align: left;\n}\n\n.headerCell {\n  position: relative;\n}\n\n.timelineCell {\n  font-weight: var(--font-weight-regular);\n}\n\n.statusCell {\n  font-weight: var(--font-weight-semibold);\n}\n\n.resizeHandle {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  cursor: col-resize;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  padding: 0;\n  position: absolute;\n  right: calc(-1 * var(--spacing-0-5));\n  top: 0;\n  touch-action: none;\n  user-select: none;\n  width: var(--spacing-1);\n  z-index: 1;\n}\n\n.resizeHandle::before {\n  background-color: var(--stroke-neutral-silver, #cccccc);\n  content: '';\n  height: 60%;\n  width: 1px;\n}\n\n.resizeHandle:hover::before,\n.resizeHandle:active::before {\n  background-color: var(--stroke-neutral-dark);\n  width: 2px;\n}\n\n.resizeHandle:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: calc(-1 * var(--spacing-0-5));\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .timelineContainer {\n    padding: var(--spacing-3);\n  }\n\n  .timelineHeader,\n  .timelineRow {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-1);\n  }\n\n  .headerCell {\n    font-size: var(--font-size-xs);\n    font-weight: var(--font-weight-semibold);\n  }\n\n  .timelineCell {\n    padding: var(--spacing-1) 0;\n  }\n\n  .date,\n  .time,\n  .event,\n  .details,\n  .observation {\n    font-size: var(--font-size-xs);\n  }\n\n  .dateTime {\n    flex-direction: row;\n    gap: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineContainer": `ukfMz4`,
	"timelineTable": `XSIWZd`,
	"timelineHeader": `PzVCHs`,
	"timelineRow": `H8z0pY`,
	"timelineBody": `m4L2dB`,
	"timelineRowEven": `mp7Ece`,
	"timelineRowOdd": `WYwxwE`,
	"headerCell": `QQ8XxB`,
	"timelineCell": `nDkUSv`,
	"statusCell": `AKpPSf`,
	"resizeHandle": `SV7d6Y`,
	"date": `QGnuau`,
	"time": `G6DKxf`,
	"event": `zuTPlf`,
	"details": `x00dYM`,
	"observation": `XzhAwG`,
	"dateTime": `dQQEGm`
};
module.exports = ___CSS_LOADER_EXPORT___;
